/**
 * Given a URL to a fluid document, returns the decoded document name, defined as the last segment of the path name
 * excluding the .fluid extension.
 * Ex: https://contoso.sharepoint.com/:u:/r/personal/userName/Documents/Project%20Moca/Test%20File.fluid?queryString produces Test File
 * NOTE: This is not going to work for sharing links because those simply carry a token in the path name.
 */
export default function getDocumentName(documentUrl: string) {
    const pathname = new URL(documentUrl).pathname;
    return decodeURI(pathname.substr(pathname.lastIndexOf('/') + 1).replace('.fluid', ''));
}
